const TODO_ID = () => `t-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;

export const emptyStickyContent = () => ({
  v: 1,
  title: '',
  items: [],
  notes: '',
});

export const makeTodoItem = (text = '', done = false) => ({
  id: TODO_ID(),
  text: String(text || ''),
  done: !!done,
});

/** Plain-Text mit □/☑ in strukturierten Content wandeln */
export const migratePlainToContent = (body = '') => {
  const lines = String(body || '').split(/\r?\n/);
  const items = [];
  const other = [];
  let title = '';

  lines.forEach((line, idx) => {
    const trimmed = line.trim();
    const open = trimmed.match(/^(?:□|☐|- \[ \]|\[\s?\])\s*(.*)$/i);
    const closed = trimmed.match(/^(?:☑|✓|✔|- \[x\]|\[x\])\s*(.*)$/i);
    if (open) {
      items.push(makeTodoItem(open[1], false));
      return;
    }
    if (closed) {
      items.push(makeTodoItem(closed[1], true));
      return;
    }
    if (!title && trimmed && items.length === 0 && other.length === 0 && idx < 3) {
      title = trimmed;
      return;
    }
    other.push(line);
  });

  return {
    v: 1,
    title,
    items,
    notes: other.join('\n').replace(/^\n+/, ''),
  };
};

export const parseStickyContent = (body) => {
  const raw = String(body || '');
  if (raw.startsWith('{')) {
    try {
      const data = JSON.parse(raw);
      if (data && Number(data.v) >= 1 && Array.isArray(data.items)) {
        return {
          v: 1,
          title: String(data.title || ''),
          items: data.items.map((it) => ({
            id: String(it.id || TODO_ID()),
            text: String(it.text || ''),
            done: !!it.done,
          })),
          notes: String(data.notes || ''),
          structured: true,
        };
      }
    } catch (_) {
      /* fall through */
    }
  }

  // Legacy: Checklisten-Zeichen → structured
  if (/(?:□|☐|☑|✓|✔|- \[[ x]\])/i.test(raw)) {
    return { ...migratePlainToContent(raw), structured: true };
  }

  return {
    v: 1,
    title: '',
    items: [],
    notes: raw,
    structured: false,
  };
};

export const serializeStickyContent = (content) =>
  JSON.stringify({
    v: 1,
    title: String(content?.title || ''),
    items: Array.isArray(content?.items)
      ? content.items.map((it) => ({
          id: String(it.id || TODO_ID()),
          text: String(it.text || ''),
          done: !!it.done,
        }))
      : [],
    notes: String(content?.notes || ''),
  });

export const contentFromBlock = (block) => {
  if (block?.content) {
    return serializeStickyContent({
      title: block.content.title || block.label || '',
      items: (block.content.items || []).map((t) =>
        typeof t === 'string' ? makeTodoItem(t, false) : makeTodoItem(t.text, !!t.done)
      ),
      notes: block.content.notes || '',
    });
  }
  return block?.body || '';
};
